import React, { useEffect, useState, useMemo } from "react";
import { connect } from "react-redux";
import { getDataFromAPI } from "../../HandleAPICalls/actions";
import AgentRoster from "./Component";


const Cst_Rooster_Container = (props) => {

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
 const [open,setOpen]=useState(false)
const [agentData,setAgentData]=useState(null)
const Rooster_list=()=>{
     props.getDataFromAPI(
      "/partner/api/v1/whatsapp/agent-schedule",
      "GET",
      undefined,
      (response) => {
      
        setAgentData(response)
     
        setLoading(false);

      },
      (error) => {
        setError("Failed to fetch coupons");
        setLoading(false);
      }
    );
}
  useEffect(() => {

    setLoading(true);
        Rooster_list()

 
  }, [props]);
function transformPayload(input) {
  const [start, end] = input.time.split(" - ");

  return {
    agentEmail: input.email,
    agentTime: [
      {
        days: [input.day],
        startTime: start.slice(0, 5),
        endTime: end.slice(0, 5),
        isActive: input.status === "Active" ? false : true
      }
    ]
  };
}



// API call function
const update_roster = (e,input) => {
  console.log("input",input)
  const payload = transformPayload(input); // ✅ transform before sending
  console.log("Final Payload Sent:", payload);

  setLoading(true);
  
  props.getDataFromAPI(
    "/partner/api/v1/chat-assignment/update-agent",
    "PUT",
    payload,
    (response) => {
      console.log("response", response);
      //setAgentData(response);
     setLoading(true);
     setOpen(false)
      setTimeout(() => {
           Rooster_list()
      }, 1000);
    
    },
    () => {
      setLoading(false);
    }
  );
};


  return (
    <>
  

   

      <AgentRoster
      rawAgentData={agentData}
      update_roster={update_roster}
      setOpen={setOpen}
      open={open}
      />
    </>
  );
};

function mapStateToProps(state) {
  return {
    // Add redux state here if needed
  };
}

export default connect(mapStateToProps, {
  getDataFromAPI,
})(Cst_Rooster_Container);
